
















import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class MenuItem extends Vue {
  @Prop({ default: "" }) readonly title!: string;
  @Prop({ default: "" }) readonly url!: string;
  @Prop({ required: true }) readonly icon!: string;
  @Prop({ default: 32 }) readonly iconSize!: number;

  onItemClick() {
    this.$router.push({ name: this.url });
  }

  get size() {
    if (this.iconSize === 16) {
      return "md";
    }
    return "xl";
  }
}
